export default "__VITE_ASSET__Z33wgIAU__"